var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEditIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M11.107 6.07 9.928 4.893l-7.761 7.762v1.178h1.178zm1.178-1.178 1.178-1.178-1.178-1.178-1.178 1.178zM4.035 15.5H.5v-3.536L11.696.767a.833.833 0 0 1 1.178 0l2.358 2.358a.833.833 0 0 1 0 1.178z"
})));
export { SvgEditIcon as ReactComponent };
export default __webpack_public_path__ + "e7f3aefcdb8c961d14c014bb7a525b7f.svg";